import config from "@/config";
import http from "@/utils/request";

export default {
	performanceList: {
		url: `${config.API_URL}/admin/report/performanceList`,
		name: "获取督导业绩统计",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	combo: {
		url: `${config.API_URL}/admin/report/combo`,
		name: "获取家庭套餐业绩列表",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	performanceOrder: {
		url: `${config.API_URL}/admin/report/performanceOrder`,
		name: "获取督导业绩明细",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	specialist: {
		role: {
			url: `${config.API_URL}/admin/role/roleList`,
			name: "获取角色列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		cycle: {
			url: `${config.API_URL}/admin/report/selectAgentCycle`,
			name: "获取结算周期",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		company: {
			url: `${config.API_URL}/admin/report/getSoureTypeArr`,
			name: "获取所属公司",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		account: {
			url: `${config.API_URL}/admin/report/selectStaffCommission`,
			name: "获取员工列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		deptUsers: {
			url: `${config.API_URL}/admin/report/selectDeptAllUsers`,
			name: "获取部门所有用户",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		count: {
			url: `${config.API_URL}/admin/report/selectStaffCommissionStatistic`,
			name: "获取汇总信息",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		list: {
			url: `${config.API_URL}/admin/report/selectStaffCommissionList`,
			name: "获取专员业绩列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		lists: {
			url: `${config.API_URL}/admin/report/selectItemsDetails`,
			name: "获取订单明细列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		itemsOrderDetail: {
			url: `${config.API_URL}/admin/report/selectItemsOrderDetail`,
			name: "获取订单项目相关明细",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/report/selectStaffCommissionOrderLog`,
			name: "获取当期相关订单列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	// 入群邀请统计
	inviteJoinGroupLists: {
		url: `${config.API_URL}/admin/report/inviteJoinGroupLists`,
		name: "获取入群邀请列表",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	inviteJoinGroupStore: {
		url: `${config.API_URL}/admin/report/inviteJoinGroupStore`,
		name: "新增/编辑入群记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	inviteJoinGroupInfo: {
		url: `${config.API_URL}/admin/report/inviteJoinGroupInfo`,
		name: "获取入群记录详情",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	inviteJoinGroupDelete: {
		url: `${config.API_URL}/admin/report/inviteJoinGroupDelete`,
		name: "删除入群记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	// 内训情况统计
	internalTrainingLists: {
		url: `${config.API_URL}/admin/report/internalTrainingLists`,
		name: "获取内训情况列表",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	internalTrainingStore: {
		url: `${config.API_URL}/admin/report/internalTrainingStore`,
		name: "新增/编辑内训记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	internalTrainingInfo: {
		url: `${config.API_URL}/admin/report/internalTrainingInfo`,
		name: "获取内训记录详情",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	internalTrainingDelete: {
		url: `${config.API_URL}/admin/report/internalTrainingDelete`,
		name: "删除内训记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	// 客户投诉退款统计
	complaintRefundLists: {
		url: `${config.API_URL}/admin/report/ComplaintRefundLists`,
		name: "获取客户投诉退款列表",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	complaintRefundStore: {
		url: `${config.API_URL}/admin/report/ComplaintRefundStore`,
		name: "新增/编辑客户投诉退款记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	complaintRefundInfo: {
		url: `${config.API_URL}/admin/report/ComplaintRefundInfo`,
		name: "获取客户投诉退款记录详情",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	complaintRefundDelete: {
		url: `${config.API_URL}/admin/report/ComplaintRefundDelete`,
		name: "删除客户投诉退款记录",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	// 业绩报表
	performanceReport: {
		url: `${config.API_URL}/admin/report/performanceReport`,
		name: "获取业绩报表数据",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 员工产品销售明细
	selectAdminUserItemsDetails: {
		url: `${config.API_URL}/admin/report/selectAdminUserItemsDetails`,
		name: "获取员工产品销售明细",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 代理业绩统计
	agentPerformance: {
		url: `${config.API_URL}/admin/report/agentPerformance`,
		name: "获取代理业绩统计",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 辅导老师列表
	adminList: {
		url: `${config.API_URL}/admin/report/adminList`,
		name: "获取辅导老师列表",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 代理增量统计
	agentComparison: {
		url: `${config.API_URL}/admin/report/agentComparison`,
		name: "获取代理增量统计列表",
		post: async function (data = {}, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	// 代理商对比列表
	agentComparisonList: {
		url: `${config.API_URL}/admin/report/agentComparisonList`,
		name: "获取代理商对比列表",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
};
